/**
 * Patient workflow statuses for the eligibility worklist (`PatientStatus` in clinical_trials).
 */

/** User-managed workflow status that determines the patient's dashboard tab. */
export enum PatientStatus {
  UnderEvaluation = "Under Evaluation",
  UnderPreScreening = "Under Pre-Screening",
  AwaitingMdConfirmation = "Awaiting MD Confirmation",
  ConsentPending = "Consent Pending",
  UnderScreening = "Under Screening",
  Ineligible = "Ineligible",
  Recruited = "Recruited",
  ArchivePatients = "Archive Patients",
}

/** Badge foreground/background colors for one patient status. */
export interface PatientStatusBadgeStyle {
  textColor: string;
  bgColor: string;
}

/** Design-token colors for each canonical patient status badge. */
export const PATIENT_STATUS_BADGE_STYLES: Record<
  PatientStatus,
  PatientStatusBadgeStyle
> = {
  [PatientStatus.UnderEvaluation]: {
    textColor: "#0F0F0F",
    bgColor: "#F5F5F5",
  },
  [PatientStatus.UnderPreScreening]: {
    textColor: "#0F0F0F",
    bgColor: "#F5F5F5",
  },
  [PatientStatus.AwaitingMdConfirmation]: {
    textColor: "#0F0F0F",
    bgColor: "#F5F5F5",
  },
  [PatientStatus.ConsentPending]: {
    textColor: "#0F0F0F",
    bgColor: "#F5F5F5",
  },
  [PatientStatus.UnderScreening]: {
    textColor: "#0F0F0F",
    bgColor: "#F5F5F5",
  },
  [PatientStatus.Ineligible]: {
    textColor: "#0F0F0F",
    bgColor: "#F5F5F5",
  },
  [PatientStatus.Recruited]: {
    textColor: "#0F0F0F",
    bgColor: "#F5F5F5",
  },
  [PatientStatus.ArchivePatients]: {
    textColor: "#0F0F0F",
    bgColor: "#F5F5F5",
  },
};

/** Fallback badge colors when the API returns an unknown status string. */
export const DEFAULT_PATIENT_STATUS_BADGE_STYLE: PatientStatusBadgeStyle = {
  textColor: "#374151",
  bgColor: "#F3F4F6",
};
